// extracted by mini-css-extract-plugin
module.exports = {"logoWraper":"layout_logoWraper__Utj7L","logo":"layout_logo__9vD2G"};